import { Home } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/** Главная клиники (4.1, шаг 7): чек-лист запуска, статус оплаты, записи на сегодня. Все роли клиники. */
export const section = defineSection({
  id: 'org.home',
  area: 'clinic',
  path: 'home',
  roles: ['OWNER', 'MED_DIRECTOR', 'OPS_DIRECTOR', 'DOCTOR', 'FRONT_DESK', 'HR', 'ACCOUNTANT'],
  icon: Home,
  titleKey: 'home:pageTitle',
  namespaces: ['portal', 'billing'],
  navGroup: 'work',
  order: 0,
  navRoles: ['OWNER', 'MED_DIRECTOR', 'OPS_DIRECTOR', 'HR', 'ACCOUNTANT'],
  load: () => import('./HomePage'),
});
